module.exports = new __parcel__URL__("loader.24d4c9b9.svg").toString();